<template>
  <div>
    <sc-text tag="h2" v-if="fields && fields.heading" :field="fields.heading" />
    <sc-rich-text v-if="fields && fields.content" :field="fields.content" />
  </div>
</template>

<script>
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ContentBlock',
  components: {
    ScText: Text,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
